import config from 'config'
import $axios from '@/axios-instance.js'

export const authService = {
  login,
  logout,
  generateToken,
  resetPassword
}

function login (username, password) {
  return $axios.post(`${process.env.ROOT_API}/auth`, { username, password })
    .then(response => {
      const user = response.data.result
      if (user.token) {
        return user
      }
    }).catch((err) => {
      return Promise.reject(err)
    })
}

function logout () {
  localStorage.removeItem('user')
  window.location = config.loginUrl
}

function generateToken (email) {
  return $axios.post(`${process.env.ROOT_API}/generate-reset-password-token`, { email }).then(response => {
    return response.data
  }).catch((err) => {
    console.error(err)
  })
}

function resetPassword (token, password) {
  return $axios.post(`${process.env.ROOT_API}/reset-password`, { resetPasswordToken: token, password: password }).then(response => {
    return response.data
  }).catch((err) => {
    console.error(err)
  })
}



// WEBPACK FOOTER //
// ./src/services/auth.service.js